export default __webpack_public_path__ + "static/media/background-login.7405ac13.svg";